module.exports = __webpack_public_path__ + "static/img/epidemic-9.0699a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-9.png
// module id = ooSc
// module chunks = 1